import { render, staticRenderFns } from "./appHologramRevisions.vue?vue&type=template&id=62f65e96&scoped=true"
import script from "./appHologramRevisions.vue?vue&type=script&lang=js"
export * from "./appHologramRevisions.vue?vue&type=script&lang=js"
import style0 from "./appHologramRevisions.vue?vue&type=style&index=0&id=62f65e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f65e96",
  null
  
)

export default component.exports